"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewBoldIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../createIconComponent"));
var ViewBold = function ViewBold(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.61 13c-2.17 2.39-5.32 4.65-8.64 5H12c-3.63-.08-6.84-2.11-9.29-4.66L2.38 13a1.5 1.5 0 010-2c2.37-2.6 6-5.08 9.62-5a9.46 9.46 0 013.75.77 15.49 15.49 0 013.4 2A18 18 0 0121.62 11a1.48 1.48 0 01-.01 2zm1.48-3.32C20.46 6.77 16.59 4.2 12.58 4H12C7.75 4 3.88 6.47 1.06 9.5l-.15.16a3.46 3.46 0 000 4.67c1.2 1.33 5.56 5.67 11 5.67h.26c5.4 0 9.76-4.34 11-5.67a3.43 3.43 0 00-.08-4.66z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 8h-.39a.22.22 0 00-.2.14.26.26 0 000 .24 2 2 0 01-2.91 2.67.26.26 0 00-.24 0 .26.26 0 00-.16.18A3.32 3.32 0 008 12a4 4 0 104-4z"
  }));
};
ViewBold.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const ViewBoldIcon = exports.ViewBoldIcon = (0, _createIconComponent.default)(ViewBold, 'ViewBold');